<template>
  <div class="log-bg-2">
    <!-- Header -->
    <div class="header bg-gradient-success mid-mid-2">

      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="" fill="#ffd538" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--9 pb-5 ">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <img src="https://app.manzanaverde.la/img/logo.svg" alt="" style="
    width: 150px;
">
                <br>
                <br>

              </div>
              <form role="form" @submit.prevent="login" @keydown="form.errors.clear($event.target.name)">
                <base-input
                  class="mb-3"
                  prepend-icon="ni ni-email-83"
                  v-model="form.email"
                  :error="form.errors.get('email')"
                  placeholder="Correo"
                  required>
                </base-input>

                <base-input
                  class="mb-3"
                  prepend-icon="ni ni-lock-circle-open"
                  v-model="form.password"
                  type="password"
                  :error-messages="form.errors.get('password')"
                  placeholder="Contraseña"
                  required
                  @keyup.enter.native="login"
                  :error="form.errors.get('password')"

                >
                </base-input>

                <div class="text-center">
                  <base-button :is-loading="isLoading" :disabled="isDisabled" type="primary" class="my-4"
                               @click="login()">Entrar
                  </base-button>
                </div>
              </form>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Form from '../../utils/Form'
  import FormBackend from '../../utils/FormBackend'

  export default {
    data() {
      return {
        form: new Form({
          email: '',
          password: ''
        }),
        formBackend: null,
        isLoading: false,
        //isDisabled:false,
        model: {
          email: '',
          password: '',
          rememberMe: false,

        }
      };
    },
    computed: {
      isDisabled() {
        return this.form.incompleted() || this.isLoading
      }
    },
    methods: {
      login() {
        if (this.isDisabled) {
          return false
        }

        this.isLoading = true
        this.form.post('/auth/login')
          .then((data) => {
            this.$store.dispatch('LOGIN', data)
          })
          .catch(() => {
            this.isLoading = false
            this.form.password = ''
          })
        this.formBackend = new FormBackend({
          email: this.form.email,
          password: this.form.password
        })
        this.formBackend.post('/catering/login')
          .then((data) => {
            this.$store.dispatch('LOGIN_BACKOFFICE', data)
          })
          .catch(() => {
            // Backoffice login is optional — don't block Catering login on failure
          })
      }
    }
  };
</script>
<style>
  .log-bg-2 {
    background-color: #ffd538;
    height: 100vh;
  }

  .mid-mid-2 {
    padding-bottom: 50vh !important;
  }
</style>
